import { api } from "./apiConfig"

export const ReviewsAPI = {
    get: async function () {
        const apiCall = await api();
        const response = await apiCall.request({
            url: "Review/GetReviews",
            method: "GET",
        })
        return response.data
    }
}